<template>
  <b-container fluid class="content landing-page">
    <b-breadcrumb :items="breadcrumbs" class="breadcrumbs"></b-breadcrumb>
    <b-container fluid>
      <title-page
        :title="'Approval Hasil Ground Chek'"
        :subtitle="'Lakukan pemeriksaan data berdasarkan isian hasil ground check anomali.'"
      />
      <b-row>
        <b-col lg="2" md="6" sm="12">
          <BSelectWithValidation v-model="kodeProv" name="Provinsi">
            <option value="">Pilih Provinsi</option>
            <option
              v-for="item in provinsis"
              :value="item.kode_prov"
              v-bind:key="item.kode_prov"
            >
              {{ item.nama_prov }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="6" sm="12">
          <BSelectWithValidation v-model="kodeKab" name="Kabupaten/Kota">
            <option value="">Pilih Kabupaten/Kota</option>
            <option
              v-for="item in kabupatenKotas"
              :value="item.kode_kab"
              v-bind:key="item.kode_kab"
            >
              {{ item.nama_kab }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="6" sm="12">
          <BSelectWithValidation v-model="kodeKec" name="Kecamatan">
            <option value="">Pilih Kecamatan</option>
            <option
              v-for="item in kecamatans"
              :value="item.kode_kec"
              v-bind:key="item.kode_kec"
            >
              {{ item.nama_kec }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="6" sm="12">
          <BSelectWithValidation v-model="kodeDesa" name="Desa/Kelurahan">
            <option value="">Pilih Desa/Kelurahan</option>
            <option
              v-for="item in desaKelurahans"
              :value="item.kode_desa"
              v-bind:key="item.kode_desa"
            >
              {{ item.nama_desa }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="6" sm="12">
          <BSelectWithValidation
            v-model="kodeSls"
            name="Satuan Lingkungan Setempat"
          >
            <option value="">Pilih Satuan Lingkungan Setempat</option>
            <option
              v-for="item in satuanLingkunganSetempats"
              :value="item.kode_sls"
              v-bind:key="item.kode_sls"
            >
              {{ item.nama_sls }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="6" sm="12">
          <BSelectWithValidation
            v-model="statusKeberadaan"
            name="Status Keberadaan"
          >
            <option value="">Pilih Status Keberadaan</option>
            <option value="1">Ditemukan</option>
            <option value="2">Tidak Ditemukan</option>
            <option value="3">Pindah</option>
            <option value="4">Meninggal</option>
          </BSelectWithValidation>
        </b-col>
      </b-row>
      <legend>Daftar Penduduk Hasil Ground Check</legend>
      <div class="table-responsive">
        <b-table
          v-if="datas.length > 0"
          class="table table-primary"
          :items="datas"
          :fields="fields"
          bordered
          striped
          hover
        >
          <template v-slot:cell(no)="data"> {{ data.index + 1 }}. </template>
          <template v-slot:cell(nama)="data">
            {{ data.item.nama == null ? "-" : data.item.nama }}.
          </template>
          <template v-slot:cell(nik_baru)="data">
            {{ data.item.nik_baru == null ? "-" : data.item.nik_baru }}.
          </template>
          <template v-slot:cell(nomor_kk_baru)="data">
            {{
              data.item.nomor_kk_baru == null ? "-" : data.item.nomor_kk_baru
            }}.
          </template>
          <template v-slot:cell(status_keberadaan)="data">
            {{ masters.status_keberadaan[data.item.status_keberadaan] }}
          </template>
          <template v-slot:cell(status_bps)="data">
            {{
              data.item.is_approved_bps == 0
                ? "Belum Diapprove"
                : "Sudah Diapprove"
            }}
          </template>
          <template v-slot:cell(status_dukcapil)="data">
            {{
              data.item.is_approved_dukcapil == 0
                ? "Belum Diapprove"
                : "Sudah Diapprove"
            }}
          </template>
          <template v-slot:cell(aksi)="data">
            <div class="text-center">
              <b-btn
                class="ml-1 btn btn-sm btn-success"
                @click="periksa(1, data.item)"
                >Periksa</b-btn
              >
            </div>
          </template>
        </b-table>
      </div>
      <legend>Daftar Penduduk Tambahan Hasil Ground Check</legend>
      <div class="table-responsive">
        <b-table
          v-if="dataBarus.length > 0"
          class="table table-primary"
          :items="dataBarus"
          :fields="baruFields"
          bordered
          striped
          hover
        >
          <template v-slot:cell(no)="data"> {{ data.index + 1 }}. </template>
          <template v-slot:cell(status_keberadaan)="data">
            {{ masters.status_keberadaan[data.item.status_keberadaan] }}
          </template>
          <template v-slot:cell(status_bps)="data">
            {{
              data.item.is_approved_bps == 0
                ? "Belum Diapprove"
                : "Sudah Diapprove"
            }}
          </template>
          <template v-slot:cell(status_dukcapil)="data">
            {{
              data.item.is_approved_dukcapil == 0
                ? "Belum Diapprove"
                : "Sudah Diapprove"
            }}
          </template>
          <template v-slot:cell(aksi)="data">
            <div class="text-center">
              <b-btn
                class="ml-1 btn btn-sm btn-success"
                @click="periksa(2, data.item)"
                >Periksa</b-btn
              >
            </div>
          </template>
        </b-table>
      </div>
      <div v-if="itemSelected.status_keberadaan == 1">
        <b-row class="text-right">
          <b-col cols="10">
            <legend class="text-left">Hasil Ground Check (Ditemukan)</legend>
          </b-col>
          <b-col>
            <b-button variant="primary">Approve</b-button>
          </b-col>
        </b-row>
        <b-alert show variant="info"
          >Perhatikan perubahan data sebelum dan sesudah dilakukan ground check,
          jika sudah sesuai klik tombol approve untuk memberikan flag sudah
          selesai diperiksa!</b-alert
        >
        <table class="table table-primary">
          <thead>
            <tr>
              <th></th>
              <th>Data Awal</th>
              <th>Data Setelah Ground Check</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-right">Nama Lengkap:</td>
              <td>{{ dataAwal.nama }}</td>
              <td>{{ itemSelected.nama }}</td>
            </tr>
            <tr>
              <td class="text-right">Nomor Induk Kependudukan:</td>
              <td>{{ dataAwal.nik }}</td>
              <td>{{ itemSelected.nik_baru }}</td>
            </tr>
            <tr>
              <td class="text-right">Nomor Kartu Keluarga:</td>
              <td>{{ dataAwal.nomor_kk }}</td>
              <td>{{ itemSelected.nomor_kk_baru }}</td>
            </tr>
            <tr>
              <td class="text-right">Jenis Kelamin:</td>
              <td>{{ masters.jenis_kelamin[dataAwal.jenis_kelamin] }}</td>
              <td>{{ masters.jenis_kelamin[itemSelected.jenis_kelamin] }}</td>
            </tr>
            <tr>
              <td class="text-right">Tanggal Lahir:</td>
              <td>{{ dataAwal.tanggal_lahir | formatDate }}</td>
              <td>{{ itemSelected.tanggal_lahir | formatDate }}</td>
            </tr>
            <tr>
              <td class="text-right">Agama:</td>
              <td>{{ masters.agama[dataAwal.agama] }}</td>
              <td>{{ masters.agama[itemSelected.agama] }}</td>
            </tr>
            <tr>
              <td class="text-right">Pendidikan:</td>
              <td>{{ masters.pendidikan[dataAwal.pendidikan] }}</td>
              <td>{{ masters.pendidikan[itemSelected.pendidikan] }}</td>
            </tr>
            <tr>
              <td class="text-right">Jenis Pekerjaan:</td>
              <td>{{ dataAwal.pekerjaan }}</td>
              <td>{{ itemSelected.pekerjaan }}</td>
            </tr>
            <tr>
              <td class="text-right">Status Pernikahan:</td>
              <td>
                {{ masters.status_pernikahan[dataAwal.status_kawin] }}
              </td>
              <td>
                {{ masters.status_pernikahan[itemSelected.status_kawin] }}
              </td>
            </tr>
            <tr>
              <td class="text-right">Status Hubungan Dalam Keluarga:</td>
              <td>
                {{
                  masters.status_hubungan_keluarga[
                    dataAwal.status_hubungan_keluarga
                  ]
                }}
              </td>
              <td>
                {{
                  masters.status_hubungan_keluarga[
                    itemSelected.status_hubungan_keluarga
                  ]
                }}
              </td>
            </tr>
            <tr>
              <td class="text-right">Kewarganegaraan:</td>
              <td>
                {{ masters.kewarganegaraan[dataAwal.kewarganegaraan] }}
              </td>
              <td>
                {{ masters.kewarganegaraan[itemSelected.kewarganegaraan] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="itemSelected.status_keberadaan == 2">
        <b-row class="text-right">
          <b-col cols="10">
            <legend class="text-left">
              Hasil Ground Check (Tidak Ditemukan)
            </legend>
          </b-col>
          <b-col>
            <b-button variant="primary">Approve</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <table class="w-100">
              <tr>
                <td>Nama Lengkap</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.nama }}</td>
              </tr>
              <tr>
                <td>Nomor Induk Kependudukan</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.nik }}</td>
              </tr>
              <tr>
                <td>Nomor Kartu Keluarga</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.nomor_kk }}</td>
              </tr>
              <tr>
                <td>Jenis Kelamin</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{ masters.jenis_kelamin[dataAwal.jenis_kelamin] }}
                </td>
              </tr>
              <tr>
                <td>Tanggal Lahir</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.tanggal_lahir | formatDate }}</td>
              </tr>
              <tr>
                <td>Agama</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ masters.agama[dataAwal.agama] }}</td>
              </tr>
              <tr>
                <td>Pendidikan</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ masters.pendidikan[dataAwal.pendidikan] }}</td>
              </tr>
              <tr>
                <td>Jenis Pekerjaan:</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.pekerjaan }}</td>
              </tr>
              <tr>
                <td>Status Pernikahan</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{ masters.status_pernikahan[dataAwal.status_kawin] }}
                </td>
              </tr>
              <tr>
                <td>Status Hubungan Dalam keluarga</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{
                    masters.status_hubungan_keluarga[
                      dataAwal.status_hubungan_keluarga
                    ]
                  }}
                </td>
              </tr>
              <tr>
                <td>Kewarganegaraan</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{
                    dataAwal.kewarganegaraan == 0
                      ? "Warga Negara Indonesia"
                      : "Warga Negara Asing"
                  }}
                </td>
              </tr>
            </table>
          </b-col>
          <b-col>
            <b-alert show variant="info"
              >Jika penduduk tersebut benar tidak ditemukan dilapangan saat
              ground check klik tombol approve untuk memberikan flag sudah
              selesai diperiksa!</b-alert
            >
          </b-col>
        </b-row>
      </div>
      <div v-if="itemSelected.status_keberadaan == 3">
        <b-row class="text-right">
          <b-col cols="10">
            <legend class="text-left">Hasil Ground Check (Pindah)</legend>
          </b-col>
          <b-col>
            <b-button variant="primary">Approve</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <table class="w-100">
              <tr>
                <td>Nama Lengkap</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.nama }}</td>
              </tr>
              <tr>
                <td>Nomor Induk Kependudukan</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.nik }}</td>
              </tr>
              <tr>
                <td>Nomor Kartu Keluarga</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.nomor_kk }}</td>
              </tr>
              <tr>
                <td>Jenis Kelamin</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{ masters.jenis_kelamin[dataAwal.jenis_kelamin] }}
                </td>
              </tr>
              <tr>
                <td>Tanggal Lahir</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.tanggal_lahir | formatDate }}</td>
              </tr>
              <tr>
                <td>Agama</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ masters.agama[dataAwal.agama] }}</td>
              </tr>
              <tr>
                <td>Pendidikan</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ masters.pendidikan[dataAwal.pendidikan] }}</td>
              </tr>
              <tr>
                <td>Jenis Pekerjaan:</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.pekerjaan }}</td>
              </tr>
              <tr>
                <td>Status Pernikahan</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{ masters.status_pernikahan[dataAwal.status_kawin] }}
                </td>
              </tr>
              <tr>
                <td>Status Hubungan Dalam keluarga</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{
                    masters.status_hubungan_keluarga[
                      dataAwal.status_hubungan_keluarga
                    ]
                  }}
                </td>
              </tr>
              <tr>
                <td>Kewarganegaraan</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{
                    dataAwal.kewarganegaraan == 0
                      ? "Warga Negara Indonesia"
                      : "Warga Negara Asing"
                  }}
                </td>
              </tr>
            </table>
          </b-col>
          <b-col>
            <b-alert show variant="info"
              >Perhatikan perubahan data alamat sebelum dan sesudah dilakukan
              ground check, jika sudah sesuai klik tombol approve untuk
              memberikan flag sudah selesai diperiksa!</b-alert
            >
          </b-col>
        </b-row>
      </div>
      <div v-if="itemSelected.status_keberadaan == 4">
        <b-row class="text-right">
          <b-col cols="10">
            <legend class="text-left">Hasil Ground Check (Meninggal)</legend>
          </b-col>
          <b-col>
            <b-button variant="primary">Approve</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <table class="w-100">
              <tr>
                <td>Nama Lengkap</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.nama }}</td>
              </tr>
              <tr>
                <td>Nomor Induk Kependudukan</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.nik }}</td>
              </tr>
              <tr>
                <td>Nomor Kartu Keluarga</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.nomor_kk }}</td>
              </tr>
              <tr>
                <td>Jenis Kelamin</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{ masters.jenis_kelamin[dataAwal.jenis_kelamin] }}
                </td>
              </tr>
              <tr>
                <td>Tanggal Lahir</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.tanggal_lahir | formatDate }}</td>
              </tr>
              <tr>
                <td>Agama</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ masters.agama[dataAwal.agama] }}</td>
              </tr>
              <tr>
                <td>Pendidikan</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ masters.pendidikan[dataAwal.pendidikan] }}</td>
              </tr>
              <tr>
                <td>Jenis Pekerjaan:</td>
                <td style="padding: 0 10px">:</td>
                <td>{{ dataAwal.pekerjaan }}</td>
              </tr>
              <tr>
                <td>Status Pernikahan</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{ masters.status_pernikahan[dataAwal.status_kawin] }}
                </td>
              </tr>
              <tr>
                <td>Status Hubungan Dalam keluarga</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{
                    masters.status_hubungan_keluarga[
                      dataAwal.status_hubungan_keluarga
                    ]
                  }}
                </td>
              </tr>
              <tr>
                <td>Kewarganegaraan</td>
                <td style="padding: 0 10px">:</td>
                <td>
                  {{
                    dataAwal.kewarganegaraan == 0
                      ? "Warga Negara Indonesia"
                      : "Warga Negara Asing"
                  }}
                </td>
              </tr>
            </table>
          </b-col>
          <b-col>
            <b-alert show variant="info"
              >Jika penduduk tersebut benar sudah meninggal pada tanggal
              <strong>{{ itemSelected.tanggal_meninggal | formatDate }}</strong>
              berdasarkan hasil ground check klik tombol approve untuk
              memberikan flag sudah selesai diperiksa!</b-alert
            >
          </b-col>
        </b-row>
      </div>
      <div v-if="itemSelected.status_keberadaan == 5">
        <b-row class="text-right">
          <b-col cols="10">
            <legend class="text-left">
              Hasil Ground Check (Penduduk Tambahan)
            </legend>
          </b-col>
          <b-col>
            <b-button variant="primary">Approve</b-button>
          </b-col>
        </b-row>
        <table class="table table-primary">
          <thead>
            <tr>
              <th></th>
              <th>Data Hasil Ground Check</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-right">Nama Lengkap:</td>
              <td>{{ itemSelected.nama }}</td>
            </tr>
            <tr>
              <td class="text-right">Nomor Induk Kependudukan:</td>
              <td>{{ itemSelected.nik }}</td>
            </tr>
            <tr>
              <td class="text-right">Nomor Kartu Keluarga:</td>
              <td>{{ itemSelected.nomor_kk_baru }}</td>
            </tr>
            <tr>
              <td class="text-right">Jenis Kelamin:</td>
              <td>{{ masters.jenis_kelamin[itemSelected.jenis_kelamin] }}</td>
            </tr>
            <tr>
              <td class="text-right">Tanggal Lahir:</td>
              <td>{{ itemSelected.tanggal_lahir | formatDate }}</td>
            </tr>
            <tr>
              <td class="text-right">Agama:</td>
              <td>{{ masters.agama[itemSelected.agama] }}</td>
            </tr>
            <tr>
              <td class="text-right">Pendidikan:</td>
              <td>{{ masters.pendidikan[itemSelected.pendidikan] }}</td>
            </tr>
            <tr>
              <td class="text-right">Jenis Pekerjaan:</td>
              <td>{{ itemSelected.pekerjaan }}</td>
            </tr>
            <tr>
              <td class="text-right">Status Pernikahan:</td>
              <td>
                {{ masters.status_pernikahan[itemSelected.status_kawin] }}
              </td>
            </tr>
            <tr>
              <td class="text-right">Status Hubungan Dalam Keluarga:</td>
              <td>
                {{
                  masters.status_hubungan_keluarga[
                    itemSelected.status_hubungan_keluarga
                  ]
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-container>
  </b-container>
</template>

<script>
import titlePage from "@/components/Title";
import master from "../Master.js";
import dataApprovalService from "../../../services/sdpi/DataApprovalService";
import masterWilayahService from "../../../services/sdpi/MasterWilayahService";
import BSelectWithValidation from "@/components/inputs/BSelectWithValidation";
export default {
  components: { titlePage, BSelectWithValidation },
  data: () => {
    return {
      breadcrumbs: [
        {
          text: "Beranda",
          to: "/sdpi",
        },
        {
          text: "Approval",
          active: true,
        },
      ],
      masters: {},
      datas: [],
      dataBarus: [],
      fields: [
        "no",
        {
          label: "Nama",
          key: "nama",
          thStyle: { minWidth: "200px" },
        },
        {
          label: "NIK",
          key: "nik_baru",
        },
        {
          label: "Nomor KK",
          key: "nomor_kk_baru",
        },
        {
          label: "Status Keberadaan",
          key: "status_keberadaan",
          thStyle: { minWidth: "180px" },
        },
        {
          label: "Provinsi",
          key: "nama_prov",
          thStyle: { minWidth: "180px" },
        },
        {
          label: "Kabupaten/Kota",
          key: "nama_kab",
          thStyle: { minWidth: "180px" },
        },
        {
          label: "Kecamatan",
          key: "nama_kec",
          thStyle: { minWidth: "180px" },
        },
        {
          label: "Desa/Kelurahan",
          key: "nama_desa",
          thStyle: { minWidth: "250px" },
        },
        {
          label: "SLS",
          key: "nama_sls",
          thStyle: { minWidth: "180px" },
        },
        {
          label: "Status BPS",
          key: "status_bps",
          thStyle: { minWidth: "150px" },
        },
        {
          label: "Status Dukcapil",
          key: "status_dukcapil",
          thStyle: { minWidth: "150px" },
        },
        {
          key: "aksi",
          label: "Aksi",
          tdClass: "text-center",
        },
      ],
      baruFields: [
        "no",
        {
          label: "Nama",
          key: "nama",
          thStyle: { minWidth: "200px" },
        },
        {
          label: "Nomor KK",
          key: "nomor_kk_baru",
        },
        {
          label: "NIK",
          key: "nik",
        },
        {
          label: "Provinsi",
          key: "nama_prov",
          thStyle: { minWidth: "180px" },
        },
        {
          label: "Kabupaten/Kota",
          key: "nama_kab",
          thStyle: { minWidth: "180px" },
        },
        {
          label: "Kecamatan",
          key: "nama_kec",
          thStyle: { minWidth: "180px" },
        },
        {
          label: "Desa/Kelurahan",
          key: "nama_desa",
          thStyle: { minWidth: "250px" },
        },
        {
          label: "SLS",
          key: "nama_sls",
          thStyle: { minWidth: "180px" },
        },
        {
          label: "Status BPS",
          key: "status_bps",
          thStyle: { minWidth: "150px" },
        },
        {
          label: "Status Dukcapil",
          key: "status_dukcapil",
          thStyle: { minWidth: "150px" },
        },
        {
          key: "aksi",
          label: "Aksi",
          tdClass: "text-center",
        },
      ],
      provinsis: [],
      kodeProv: "",
      kabupatenKotas: [],
      kodeKab: "",
      kecamatans: [],
      kodeKec: "",
      desaKelurahans: [],
      kodeDesa: "",
      satuanLingkunganSetempats: [],
      kodeSls: "",
      statusKeberadaan: "",
      itemSelected: { status_keberadaan: null },
      dataAwal: null,
    };
  },
  methods: {
    async getDatas(param) {
      await dataApprovalService.getDataApprovalKonfirmasiNik(param).then(
        (result) => {
          this.datas = result.data.data.content;
          console.log(this.datas)
          this.getDataBarus(param);
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getDataAwal(nik, nomor_kk, kode_sls) {
      await dataApprovalService.getDataAwal(nik, nomor_kk, kode_sls).then(
        (result) => {
          this.dataAwal = result.data.data[0];
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getDataId(id) {
      await dataApprovalService.getDataId(id).then(
        (result) => {
          this.dataAwal = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getDataBarus(param) {
      await dataApprovalService.getDataApprovalBaruNik(param).then(
        (result) => {
          this.dataBarus = result.data.data.content;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getProvinsi() {
      await masterWilayahService.getProvinsi().then(
        (result) => {
          this.provinsis = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKabupatenKota(id) {
      await masterWilayahService.getKabupatenKotaByProvinsi(id).then(
        (result) => {
          this.kabupatenKotas = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKecamatan(id) {
      await masterWilayahService.getKecamatanByKabupatenKota(id).then(
        (result) => {
          this.kecamatans = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getDesaKelurahan(id) {
      await masterWilayahService.getDesaKelurahanByKecamatan(id).then(
        (result) => {
          this.desaKelurahans = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getSls(id) {
      await masterWilayahService.getSlsByDesa(id).then(
        (result) => {
          this.satuanLingkunganSetempats = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    periksa(id, item) {
      this.itemSelected = item;
      if (id == 2) {
        this.itemSelected.status_keberadaan = "5";
      }
      if (
        this.itemSelected.nik.length == 16 &&
        this.itemSelected.nomor_kk.length == 16 &&
        this.itemSelected.kode_sls != null
      ) {
        this.getDataAwal(
          this.itemSelected.nik,
          this.itemSelected.nomor_kk,
          this.itemSelected.kode_sls
        );
      } else {
        this.getDataId(this.itemSelected.nomor_kk);
      }
    },
  },
  mounted() {
    this.masters = master;
    this.getDatas(null);
    this.getProvinsi();
  },
  watch: {
    kodeProv(val) {
      if (val) {
        this.kodeKab = "";
        this.kodeKec = "";
        this.kodeDesa = "";
        this.kodeSls = "";
        this.getDatas("?kode_prov=" + val);
        this.getKabupatenKota(val);
      }
    },
    kodeKab(val) {
      if (val) {
        this.kodeKec = "";
        this.kodeDesa = "";
        this.kodeSls = "";
        this.getDatas("?kode_kab=" + val);
        this.getKecamatan(val);
      }
    },
    kodeKec(val) {
      if (val) {
        this.kodeDesa = "";
        this.kodeSls = "";
        this.getDatas("?kode_kec=" + val);
        this.getDesaKelurahan(val);
      }
    },
    kodeDesa(val) {
      if (val) {
        this.kodeSls = "";
        this.getDatas("?kode_desa=" + val);
        this.getSls(val);
      }
    },
    kodeSls(val) {
      if (val) {
        this.getDatas("?kode_sls=" + val);
      }
    },
  },
};
</script>
